import { checkResolution } from 'Functions/helpers'

const paginationOptions = (instance) => ({
    pagination: {
        el: instance.paginationEl,
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 10,
        hideOnClick: false,
    }
})

const navigationOptions = (instance) => ({
    navigation: {
        prevEl: instance.prevEl,
        nextEl: instance.nextEl,
        disabledClass: 'is-disabled',
        hiddenClass: 'is-hidden'
    }
})

const accessoriesSliderOptions = (instance, options) => ({
    loop: false,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    slidesPerColumn: 3,
    breakpoints: {
        768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            slidesPerColumn: 1,
            spaceBetween: 30,
            cssMode: false,
            pagination: {
                dynamicBullets: false
            },
        },
        1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            slidesPerColumn: 1,
            spaceBetween: 20,
            cssMode: false,
            pagination: {
                dynamicBullets: false
            },
        },
        1280: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            slidesPerColumn: 1,
            spaceBetween: 100,
            cssMode: false,
            pagination: {
                dynamicBullets: false
            }
        }
    }
})

const carouselSliderOptions = (instance, options) => ({
    loop: false,
    slidesPerView: 1.25,
    slidesPerGroup: 1,
    slidesPerColumn: 1,
    spaceBetween: 30,
    breakpoints: {
        768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 30,
            cssMode: false,
        },
        1024: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 30,
            cssMode: false,
        },
        1280: {
            slidesPerView: 2.7,
            slidesPerGroup: 2,
            spaceBetween: 30,
            cssMode: false,
        }
    }
})

const productsSliderOptions = (instance, options) => ({
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 0,
    cssMode: true,
    breakpoints: {
        1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 11,
            cssMode: false,
            pagination: {
                dynamicBullets: false
            }
        },
        1280: {
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 11,
            cssMode: false,
            pagination: {
                dynamicBullets: false
            }
        }
    }
})

const indexSliderOptions = (instance, options) => {
    options = {...options, ...{
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0
    }}

    if (!checkResolution('cxs;txs')) {
        options.autoplay = {
            delay: 8000,
        }
    }

    return options
}

const articleProductsSliderOptions = (instance, options) => ({
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 0,
    cssMode: true,
    breakpoints: {
        1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 11,
            cssMode: false,
            pagination: {
                dynamicBullets: false
            }
        }
    }
})

const articlesRecommendedSliderOptions = (instance, options) => ({
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 30,
    cssMode: true,
    breakpoints: {
        1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 24,
            cssMode: false,
            pagination: {
                dynamicBullets: false
            }
        },
        1280: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 24,
            cssMode: false,
            pagination: {
                dynamicBullets: false
            }
        }
    }
})

const productImageOptions = (instance, options) => ({
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    cssMode: true,
    on: {
        slideChange(swiper) {
            const currentImage = document.querySelector(`.js-lightbox-trigger[data-index="${swiper.activeIndex}"]`)
            const variationName = currentImage.dataset.variationName
            const decorEl = document.querySelector('.js-product-decor')
            const decorImg = document.querySelector('.js-product-decor-img')
            const decorText = document.querySelector('.js-product-decor-text')

            decorText.innerHTML = variationName
            decorImg.src = currentImage.dataset.variationImg
            decorEl.classList.toggle('is-hidden', !variationName)
        }
    }
})

const options = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        roundLengths: true,
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-product-image-slider')) {
        options = {...options, ...productImageOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-products')) {
        options = {...options, ...productsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-article-products')) {
        options = {...options, ...articleProductsSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-articles-recommended')) {
        options = {...options, ...articlesRecommendedSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-accessories')) {
        options = {...options, ...accessoriesSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-carousel')) {
        options = {...options, ...carouselSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-index')) {
        options = {...options, ...indexSliderOptions(instance, options)}
    }

    return {...options, ...instance.customOptions}
}

export default options